import { createAction, props } from '@ngrx/store';
import { PhoneGetData, PhoneValidationStatus } from '@shared/models/phone-number.interface';

export const UpdateMfePhoneFromGetData = createAction(
  '[MFE Phone] Update From Get Data',
  props<{ payload: PhoneGetData }>(),
);

export const UpdateMfePhoneNumber = createAction(
  '[MFE Phone] Update Phone Number',
  props<{ payload: string }>(),
);

export const UpdateMfePhoneMobileFlag = createAction(
  '[MFE Phone] Update Mobile Flag',
  props<{ payload: boolean }>(),
);

export const UpdateMfePhoneValidationStatus = createAction(
  '[MFE Phone] Update Validation Status',
  props<{ payload: PhoneValidationStatus }>(),
);

export const ResetMfePhone = createAction('[MFE Phone] Reset');
